module.exports = __webpack_public_path__ + "static/media/A (3).3afbc82d.jpg";